var React = require('react');

function Blob1 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M39.9,-67.2C48.6,-56.5,50.5,-40.2,56,-26.2C61.5,-12.1,70.6,-0.3,68.7,9.6C66.8,19.5,53.9,27.5,44.1,37.3C34.2,47.1,27.4,58.7,17.3,64.1C7.2,69.4,-6.3,68.4,-20.7,66.2C-35.1,64,-50.4,60.5,-56.9,50.6C-63.4,40.8,-61.1,24.6,-56.5,12.2C-51.9,-0.2,-45.1,-8.8,-42.5,-21.5C-39.9,-34.1,-41.6,-50.7,-35.2,-62.5C-28.8,-74.3,-14.4,-81.2,0.6,-82.1C15.6,-83,31.2,-77.9,39.9,-67.2Z","transform":"translate(100 100)"}));
}

Blob1.defaultProps = {"viewBox":"0 0 200 200"};

module.exports = Blob1;

Blob1.default = Blob1;
